import React from 'react';

import {EVENT_NOT_PICKED, EVENT_STATUS_REVOKED} from '@constants/variables';
import Chip from '@ui/Chip';
import {convertToInt} from '@utils/helpers';

export function isRedStatusLabel(statusId) {
    const statusIdInt = convertToInt(statusId);

    return [
        EVENT_STATUS_REVOKED,
        EVENT_NOT_PICKED,
    ].includes(statusIdInt);
}

export function renderEventStatusName (statusId, statusName, matchStatus = null, showFallback = true) {
    if (isRedStatusLabel(statusId) || matchStatus) {
        return <Chip size='small' color='error' label={statusName} />;
    }

    return showFallback ? statusName : null;
}
